import axios from '@/allotment/axios'

export default {
  nav: () => axios.get('/menu/nav'), //获取当前登录人菜单
  list: () => axios.get('/menu/list'), //获取菜单列表
  save: data => axios.post('/menu/save', data), //保存菜单
  delete: id => axios.post(`/menu/delete/${id}`) //删除菜单
}